import React, { Fragment } from 'react'
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useHistory,
} from 'react-router-dom'
import loadable from '@loadable/component'
import { getFromLocalStorage } from 'Brands/helper/storage'
import {
  isAuthenticated,
  isAuthenticatedInfluencer,
  unAuthenticatedUser,
} from './services/requests'
import LoaderComponent from '../components/Loader'
import stringDelimiter from './utils/stringDelimiter'
import langUrl from './utils/langUrl'
import RedirectRoute from './RedirectRoute'

const PrivateRoute = loadable(() => import('./PrivateRoute'), {
  fallback: <LoaderComponent visible={true} />,
})
const MobileLanding = loadable(
  () => import('Brands/containers/Landing/MobileLanding'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)

const Login = loadable(() => import('Brands/containers/Landing/Login'), {
  fallback: <LoaderComponent visible={true} />,
})
const LoginModal = loadable(() => import('./SignModal/Login'), {
  fallback: <LoaderComponent visible={true} />,
})
const BrandModal = loadable(() => import('./SignModal/Brand'), {
  fallback: <LoaderComponent visible={true} />,
})
const InfluencerModal = loadable(() => import('./SignModal/Influencer'), {
  fallback: <LoaderComponent visible={true} />,
})
const UpdateMilestone = loadable(
  () => import('../Brands/containers/MilestonesProfile/UpdateMilestoneModal'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)

const ALlInfluencers = loadable(
  () => import('../Brands/containers/Landing/MobileLanding/Influencers/index'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
const VerificationEmail = loadable(
  () => import('./SignModal/VerificationEmail'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
const BrandDashboard = loadable(
  () => import('Brands/containers/BrandDashboard'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
const Campaign = loadable(() => import('Brands/containers/Campaign'), {
  fallback: <LoaderComponent visible={true} />,
})
const Influencer = loadable(
  () => import('Influencers/containers/Dashboard/Influencer'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
const InfluencerRoutes = loadable(
  () => import('Influencers/containers/Dashboard/Influencer/InfluencerRoutes'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
const MilestonesProfile = loadable(
  () => import('Brands/containers/MilestonesProfile'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
const CompanyForm = loadable(
  () => import('Brands/containers/Authentication/CompanyForm'),
  {
    fallback: <LoaderComponent visible={true} />,
  },
)
export default function CampaignRoutes() {
  const location = useLocation()
  return (
    <Switch>
      <PrivateRoute
        path={`/${langUrl}/brand/campaign`}
        authMethod={isAuthenticated}
        component={Campaign}
      />
      <PrivateRoute
        path={`/${langUrl}/brand/profile`}
        authMethod={isAuthenticated}
        component={CompanyForm}
      />
      <PrivateRoute
        path={`/${langUrl}/milestones/update/:id`}
        authMethod={isAuthenticated}
        component={UpdateMilestone}
      />
      {/*<PrivateRoute*/}
      {/*  path="/influencers/:id"*/}
      {/*  authMethod={isAuthenticated}*/}
      {/*  component={InfluencerDetails}*/}
      {/*/>*/}
      <PrivateRoute
        path={`/${langUrl}/milestones/:id`}
        authMethod={isAuthenticated}
        component={MilestonesProfile}
      />
      <PrivateRoute
        path={`/${langUrl}/influencer`}
        authMethod={isAuthenticatedInfluencer}
        component={InfluencerRoutes}
      />
      <PrivateRoute
        path={`/${langUrl}/register`}
        authMethod={unAuthenticatedUser}
        component={Login}
      />
      <PrivateRoute
        path={`/${langUrl}/users/login`}
        authMethod={unAuthenticatedUser}
        component={LoginModal}
      />
      <PrivateRoute
        path={`/${langUrl}/register`}
        authMethod={unAuthenticatedUser}
        component={Login}
      />

      <PrivateRoute
        path={`/${langUrl}/users/brand`}
        authMethod={unAuthenticatedUser}
        component={BrandModal}
      />
      <PrivateRoute
        path={`/${langUrl}/users/influencer`}
        authMethod={unAuthenticatedUser}
        component={InfluencerModal}
      />
      <Route
        path={`/${langUrl}/all-influencers`}
        exact
        component={ALlInfluencers}
      />
      <Route
        path={`/${langUrl}/verify-email`}
        exact
        component={VerificationEmail}
      />
      {/*{getFromLocalStorage('brandData:') ? null : getFromLocalStorage(*/}
      {/*  'userData:',*/}
      {/*) ? null : (*/}
      {/*  <Fragment>*/}
      {/*   */}
      {/*  </Fragment>*/}
      {/*)}*/}
      {getFromLocalStorage('brandData:') ? (
        <Fragment>
          <Redirect to={{ pathname: `/${langUrl}/brand/dashboard` }} from="/" />
          <Route
            path={`/${langUrl}/brand/dashboard`}
            exact
            component={BrandDashboard}
          />
        </Fragment>
      ) : getFromLocalStorage('userData:') ? (
        <Fragment>
          <Redirect
            to={{ pathname: `/${langUrl}/influencer/dashboard` }}
            from="/"
          />
          <Route
            path={`/${langUrl}/influencer/dashboard`}
            exact
            component={Influencer}
          />
        </Fragment>
      ) : (
        <Fragment>
          <Route path={`/${langUrl}`} component={MobileLanding} />
          {/*<RedirectRoute to={{ pathname: `/${langUrl}` }} from="/" />*/}
          <RedirectRoute location={location} />
        </Fragment>
      )}
    </Switch>
  )
}
